import { fg } from '@atlassian/jira-feature-gating';

const IsJSCExpandAllChangesEnabledRelayprovider = {
	get(): boolean {
		return fg('jsc_list_expand_all');
	},
};

export default IsJSCExpandAllChangesEnabledRelayprovider;
